/** Returns true if the email is a Ditto email address. */
export const checkIsDittoEmail = (email: undefined | string | null): boolean =>
  (email || '').split('@')[1] === 'ditto.live'
